import Image from 'next/image'
import { type FC } from 'react'

import { Button } from '@wartek-id/button-v1'
import type { DialogProps } from '@wartek-id/dialog-v1'
import { Dialog, DialogContent, DialogOverlay } from '@wartek-id/dialog-v1'
import { Text } from '@wartek-id/text-v1'

import { useIsPrior2025 } from 'app/KinerjaShared/hooks/useIsPrior2025'

interface DialogDeliverySuccessProps extends Omit<DialogProps, 'children'> {
  count?: number
  onClick: () => void
}

const DialogDeliverySuccess: FC<DialogDeliverySuccessProps> = ({
  count = 0,
  onClick = () => {},
  ...props
}) => {
  const isPriorTo2025 = useIsPrior2025()

  return (
    <Dialog {...props}>
      <DialogOverlay />
      <DialogContent className="!rounded-lg">
        <div className="p-6 space-y-2">
          <Image
            alt=""
            src="/illustrations/img-thumbs-up.png"
            width={84}
            height={84}
          />
          <Text variant="display-sm">
            {count}{' '}
            {isPriorTo2025
              ? 'Predikat Kinerja sudah dikirim ke Pegawai'
              : 'Predikat Kinerja berhasil dikirim ke Kepala Sekolah'}
          </Text>

          <Text variant="body-lg" color="subdued">
            Anda dapat melanjutkan pengiriman jika ada yang belum dikirim. Mohon
            cek secara berkala.
          </Text>

          <div className="flex gap-5 !mt-4">
            <Button
              size="lg"
              className="w-[159px]"
              data-testid="btn-confirm"
              onClick={onClick}
            >
              Saya mengerti
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}
export default DialogDeliverySuccess
